import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import cascaderSelect from '@blade/common/components/cascader-select/index.vue';
import { isEmpty, map } from 'lodash';
import { fetchDeviceTree } from '@blade-sxp/monitor/api/device-management/control';
let default_1 = class default_1 extends Vue {
    multiple;
    fetchAPI;
    customedDisabledFunc;
    placeholder;
    options = [];
    value;
    disabled;
    collapseTags;
    async getTree() {
        try {
            let data = [];
            if (this.fetchAPI) {
                data = (await this.fetchAPI());
            }
            else {
                const { trees } = (await fetchDeviceTree());
                data = trees;
            }
            this.options = this.mapTree(data) || [];
            if (!isEmpty(data)) {
                this.$emit('data-finish', true);
            }
        }
        catch (_) { }
    }
    mounted() {
        this.getTree();
    }
    mapTree(originTree) {
        if (!isEmpty(originTree)) {
            return map(originTree, (node) => {
                const { id, children, name, nodeType } = node;
                const isGroup = nodeType === 'DEVICE_GROUP' || !nodeType;
                const mapped = {
                    ...node,
                    id: id + (isGroup ? 'DEVICE_GROUP' : ''),
                    value: id + (isGroup ? 'DEVICE_GROUP' : ''),
                    label: name,
                    children: this.mapTree(children),
                    disabled: (isEmpty(children) && isGroup) || (this.customedDisabledFunc && this.customedDisabledFunc(node)),
                };
                mapped.disabled = mapped.disabled || this.allChildrenDisabled(mapped);
                return mapped;
            });
        }
    }
    allChildrenDisabled(node) {
        const { children } = node;
        if (node.nodeType !== 'DEVICE_GROUP' && node.nodeType) {
            return false;
        }
        for (const item of children) {
            if (!item.disabled) {
                return false;
            }
        }
        return true;
    }
    onValueChange(value) {
        this.$emit('update:value', value);
    }
    onLabelChange(label) {
        this.$emit('update:label', label);
    }
    getCascaderStatus(value) {
        this.$emit('cascader-status', value);
    }
    remove(val) {
        this.$emit('remove-value', val);
    }
};
__decorate([
    Prop()
], default_1.prototype, "multiple", void 0);
__decorate([
    Prop()
], default_1.prototype, "fetchAPI", void 0);
__decorate([
    Prop()
], default_1.prototype, "customedDisabledFunc", void 0);
__decorate([
    Prop()
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop()
], default_1.prototype, "value", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "collapseTags", void 0);
default_1 = __decorate([
    Component({
        name: 'device-cascader-select',
        components: { cascaderSelect },
        i18n: {
            messages: { en: {} },
        },
    })
], default_1);
export default default_1;
